<div class="row sidebar-bar  p-0" id="sidebar-left">
  <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-1 box-user"
       [ngClass]="{'col-12 col-sm-5 col-md-4 col-lg-3 col-xl-2': connectedAs !== connectTypeUperEnum.HB_TYPE_SIMULATOR && connectedAs !== connectTypeUperEnum.HB_TYPE_OFFILINE && !isMultiBroker
      && (model?.clientSelected?.accountDesc || model?.clientSelected?.full_name || (wlConfig?.sidebar?.showProfileSuitabilityName && model?.validateSuitability))}">
    <div class="row">
      <div class="col-12 p-0 broker" *ngIf="!loading">
        <div class="photo">
          <img id="image-broker" src="{{ model.imageBroker }}" matTooltip="{{ model.brokerName }}"
               onError="this.src='./assets/images/symbols/INDISPONIVEL.PNG';"
               *ngIf="isRanking || connectedAs === connectTypeUperEnum.HB_TYPE_SIMULATOR || isMultiBroker || connectedAs === connectTypeUperEnum.HB_TYPE_OFFILINE || connectedAs === connectTypeUperEnum.HB_TYPE_MARKET_DATA">
          <div class="picture"
               *ngIf="!isRanking && connectedAs !== connectTypeUperEnum.HB_TYPE_SIMULATOR && connectedAs !== connectTypeUperEnum.HB_TYPE_OFFILINE && !isMultiBroker && connectedAs !== connectTypeUperEnum.HB_TYPE_MARKET_DATA">
            {{ model?.brokerSigle }}
          </div>
        </div>
        <div class="profile" [ngClass]="{'market-data': connectedAs === connectTypeUperEnum.HB_TYPE_MARKET_DATA}">
          <div class="col-12 p-0 offline" *ngIf="connectedAs === connectTypeUperEnum.HB_TYPE_MARKET_DATA">
            {{ model?.clientName }}
          </div>
          <div class="col-12 p-0 name"
               *ngIf="connectedAs !== connectTypeUperEnum.HB_TYPE_SIMULATOR && !isMultiBroker && (model?.clientSelected?.accountDesc || model?.clientSelected?.full_name)">
            <span class="name" matTooltip="{{ model.clientSelected.accountDesc || model.clientSelected.full_name }}">
              {{ model?.clientSelected.accountDesc || model?.clientSelected.full_name }}
            </span>
          </div>
          <div class="col-12 p-0 suitability"
               *ngIf="wlConfig?.sidebar?.showProfileSuitabilityName && connectedAs !== connectTypeUperEnum.HB_TYPE_MARKET_DATA && model?.validateSuitability">
            <span class="name">Perfil:</span>
            <span class="suitability blue" [ngClass]="{ 'yellow': model?.perfilProfile === 'MODERADO', 'purple': model?.perfilProfile === 'BALANCEADO',
              'orange': model?.perfilProfile === 'ARROJADO', 'red': model?.perfilProfile === 'AGRESSIVO' }">
              {{ model?.perfilProfile ? (model?.perfilProfile | uppercase) : ('Não encontrado' | uppercase) }}
            </span>
          </div>
        </div>
        <div class="arrow" (click)="openAssessorSearch()" matTooltip="Selecionar Cliente" *ngIf="isUserAssessor">
          <mat-icon svgIcon="arrow-expand"></mat-icon>
        </div>
        <div class="bottom" *ngIf="!loading && connectedAs === connectTypeUperEnum.HB_TYPE_OFFILINE">
          <div (click)="openBrokerAuthenticationModal()">
            <div class="icon">
              <mat-icon svgIcon="login-broker"></mat-icon>
            </div>
            <div class="btn-send">
              <span>{{ isMultiBroker ? 'Autenticar com sua corretora' : 'Autenticar com sua corretora' }}</span>
            </div>
          </div>
        </div>
        <div class="arrow" *ngIf="!loading && connectedAs === connectTypeUperEnum.HB_TYPE_OFFILINE">
          <mat-icon svgIcon="arrow-expand"></mat-icon>
        </div>
        <div class="account" *ngIf="!loading && connectedAs !== connectTypeUperEnum.HB_TYPE_OFFILINE
        && connectedAs !== connectTypeUperEnum.HB_TYPE_MARKET_DATA && model?.accountHbLogged?.length > 0">
          <mat-form-field appearance="fill">
            <mat-label class="font-weight-bold">CONTA</mat-label>
            <mat-select style="width: 335px" disableOptionCentering panelClass="select-profile" id="selected-account"
                        (click)='this.dialog.closeAll()' (selectionChange)="changeAccount()"
                        [(ngModel)]="model.selectedAccount">
              <mat-option *ngFor="let item of model?.accountHbLogged"
                          [value]="isUserAssessor ? model?.selectedAccount : item?.account">
                {{ isUserAssessor ? item : item?.account }}
              </mat-option>
              <mat-option value="sair" *ngIf="showBtnLogoutBroker">
                <mat-icon svgIcon="power"></mat-icon>
                Sair
              </mat-option>
              <mat-option value="changeBroker" *ngIf="wlConfig?.system?.isMultiBroker">
                <mat-icon svgIcon="power"></mat-icon>
                <span>Trocar Corretora</span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
